<template>
  <div class="login-page">
    <div class="login-card">
      <h1>Support Bot</h1>
      <p class="subtitle">Sign in to get support</p>
      <v-btn
        color="primary"
        :disabled="isLoading"
        @click="signIn"
      >
        Sign in
      </v-btn>
      <!-- Error Message -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      
      <!-- Loading State -->
      <div v-if="isLoading" class="loading">
        <div class="spinner"></div>
        <p>Signing in...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { authorize } from '@/services/AuthService';

export default {
  name: 'LoginPage',

  data() {
    return {
      isLoading: false,
      errorMessage: null
    };
  },

  methods: {
    async signIn() {
      this.isLoading = true;
      this.errorMessage = null;

      try {
        await authorize('login');
      } catch {
        this.errorMessage = 'Sign-in failed. Please try again.';
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 16px;
  padding: 50px 45px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 400px;
  width: 100%;
}

.login-card h1 {
  margin: 0 0 8px 0;
  font-size: 32px;
  color: #333;
  font-weight: 600;
}

.subtitle {
  margin: 0 0 32px 0;
  color: #666;
  font-size: 16px;
}

.error-message {
  margin-top: 20px;
  padding: 12px;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  color: #c33;
  font-size: 14px;
}

.loading {
  margin-top: 24px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 12px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading p {
  color: #666;
  font-size: 14px;
}
</style>